/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CabinClassType,
    CabinClassTypeFromJSON,
    CabinClassTypeFromJSONTyped,
    CabinClassTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface CabinClassTypeCriteriaOutput
 */
export interface CabinClassTypeCriteriaOutput {
    /**
     * 
     * @type {boolean}
     * @memberof CabinClassTypeCriteriaOutput
     */
    exclude?: boolean;
    /**
     * 
     * @type {CabinClassType}
     * @memberof CabinClassTypeCriteriaOutput
     */
    value?: CabinClassType;
}

export function CabinClassTypeCriteriaOutputFromJSON(json: any): CabinClassTypeCriteriaOutput {
    return CabinClassTypeCriteriaOutputFromJSONTyped(json, false);
}

export function CabinClassTypeCriteriaOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): CabinClassTypeCriteriaOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'exclude': !exists(json, 'exclude') ? undefined : json['exclude'],
        'value': !exists(json, 'value') ? undefined : CabinClassTypeFromJSON(json['value']),
    };
}

export function CabinClassTypeCriteriaOutputToJSON(value?: CabinClassTypeCriteriaOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'exclude': value.exclude,
        'value': CabinClassTypeToJSON(value.value),
    };
}


